import React from 'react'

export type KeyTabNavigationProps<TabType extends { title: string }> = {
  tabs: Record<string, TabType>
  activeTab: string
  onTabClick: (tab: string) => void
  disabled?: boolean
}

// Tabbed navigation
// Content of each tab must be handled externally
// See examples in Key Catalog (/ops/components)

/**
 * @deprecated key-* components are no longer supported.
 */
export function KeyTabNavigation<TabType extends { title: string }>(
  props: KeyTabNavigationProps<TabType>
) {
  const { activeTab, onTabClick, tabs, disabled = false } = props

  const disabledClass = disabled && 'text-gray-400 cursor-default pointer-events-none'

  return (
    <div className='w-full h-[50px] flex gap-10 px-8 border-b border-gray-200'>
      {Object.keys(tabs).map((tab) => {
        const classes =
          activeTab === tab
            ? 'border-sky-400 font-bold text-sky-400'
            : 'border-transparent text-black cursor-pointer'

        return (
          <div
            key={tab}
            className={`flex items-center border-b-4 -mb-0.5 transition-all ${classes} ${disabledClass}`}
            onClick={() => onTabClick(tab)}
          >
            <p className='text-[16px] pb-3 text-center'>{tabs[tab]?.title}</p>
          </div>
        )
      })}
    </div>
  )
}
